export default __webpack_public_path__ + "src/images/packages/monte-vista-boutique-hotel/c516069aab87558581f15c114beccd4c-2.jpg";